import React, { useState, useEffect } from 'react';
import './NewArrivals.css';
import * as Constants from '../../Constant/constant';
import SearchableSelect from '../../shared/SearchableSelect';

function BookNameList() {
    const [showBookNameList, setShowBookNameList] = useState(true);
    const [entriesToShowBookName, setEntriesToShowBookName] = useState(100);
    const [searchQueryBookName, setSearchQueryBookName] = useState('');
    const [bookNameList, setBookNameList] = useState([]);
    const [loadingBookNameList, setLoadingBookNameList] = useState(false);
    const [errorBookNameList, setErrorBookNameList] = useState(null);

    useEffect(() => {
        const fetchBookNameList = async () => {
            setLoadingBookNameList(true);
            setErrorBookNameList(null);
            try {
                const response = await fetch(Constants.API_PATH +'book_name_list'); // Replace with your API endpoint
                if (!response.ok) {
                    throw new Error('Failed to fetch book name list');
                }
                const data = await response.json();
                setBookNameList(data);
            } catch (error) {
                setErrorBookNameList(error.message);
            } finally {
                setLoadingBookNameList(false);
            }
        };

        fetchBookNameList();
    }, []);

    const handleEntriesChangeBookName = (e) => {
        setEntriesToShowBookName(e.target.value);
    };

    const handleSearchChangeBookName = (e) => {
        setSearchQueryBookName(e.target.value);
    };

    return (
        showBookNameList && (
            <div className="book-name-list-section containernew">
                {/* <nav className="breadcrumb">
                    <a href="#" className="breadcrumb-link">Home</a> /
                    <a href="#" className="breadcrumb-link">Library Management</a> /
                    <span className="breadcrumb-current">Book Name List</span>
                </nav> */}
                <h2 className="section-title">Book Name List</h2>
                <div className="filters">
                    <div className="entries">
                        Show
                        <SearchableSelect
                            value={entriesToShowBookName}
                            onChange={handleEntriesChangeBookName}
                            options={[
                                { value: '100', label: '100' },
                                { value: '50', label: '50' },
                                { value: '25', label: '25' },
                                { value: '10', label: '10' }
                            ]}
                            className="form-select"
                            clearable={false}
                        />
                        entries
                    </div>
                    <div className="search">
                        Search:
                        <input
                            type="text"
                            className="form-input"
                            value={searchQueryBookName}
                            onChange={handleSearchChangeBookName}
                            placeholder="Search..."
                        />
                    </div>
                </div>
                <div className="table-responsive">
                    {loadingBookNameList ? (
                        <p>Loading...</p>
                    ) : errorBookNameList ? (
                        <p>{errorBookNameList}</p>
                    ) : (
                        <table className="custom-table">
                            <thead>
                                <tr>
                                    <th>Sr.No.</th>
                                    <th>Book Name</th>
                                    <th>No of Books</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bookNameList.length === 0 ? (
                                    <tr>
                                        <td colSpan="3">No data available in table</td>
                                    </tr>
                                ) : (
                                    bookNameList.map((book, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{book.name}</td>
                                            <td>{book.count}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
                <div className="pagination">
                    <button disabled>Previous</button>
                    <button>Next</button>
                </div>
            </div>
        )
    );
}

export default BookNameList;